import { captureException, captureMessage } from "@/lib/client/sentryClient";

export const sendError = (error: Error, extra?: { [key: string]: unknown }) => {
  captureException(error, { extra });
};

export const reportListing = (
  listingId: number | string = "not sent",
  reason: string,
  userId?: number | string
) => {
  captureMessage(`Listing ${listingId} reported for reason: ${reason}`, {
    level: "info",
    tags: {
      type: "report-listing",
    },
    extra: {
      listingId,
      reason,
      userId,
    },
  });
};
